export const SqlOperatorType = {
  And: 0,
  Or: 1,
};
